var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"list-decomptes-table"}},[_c('decompte-table',{ref:"decompte_beneficiaire",attrs:{"tableEntry":_vm.tableParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }